import './DateTimeMixLayout.css';

import { cn } from '../../../../utils/bem';

export const cnDateTimeMixLayout = cn('DateTimeMixLayout');
